import EventDetailsContainer from './EventDetailsContainer';

export default EventDetailsContainer;
